export const CampaignTypesEnum = {
  newUsers: "newUsers",
  ReEngagement: "re-engagement",
};

export const CampaignTypesMapping = {
  [CampaignTypesEnum.newUsers]: "New installs",
  [CampaignTypesEnum.ReEngagement]: "Re-engagement",
};
